import { render } from "./DisclosureInformationPage.vue?vue&type=template&id=b5bccc54&scoped=true"
import script from "./DisclosureInformationPage.vue?vue&type=script&lang=js"
export * from "./DisclosureInformationPage.vue?vue&type=script&lang=js"

import "./DisclosureInformationPage.vue?vue&type=style&index=0&id=b5bccc54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bccc54"]])

export default __exports__